



























import { mapActions, mapState, mapGetters } from 'vuex';
import { DateTime } from 'luxon';
import { usdToOperatorCurrency } from '@/helpers/currencyHelper';
import { roundNumber } from '@/helpers/roundNumber';
import type { TokensaleParticipation } from '@/api/schema';

const defaultOptions = {
  page: 1,
  itemsPerPage: 10
};

export default {
  name: 'TokensaleView',
  data: (): unknown => ({
    options: { ...defaultOptions },
    itemsPerPage: [10, 20, 50]
  }),
  computed: {
    ...mapState('TokenSale', ['users', 'loading']),
    ...mapState('Auth', ['tokenSymbol']),
    ...mapState('app', ['isSuperAdmin']),
    ...mapState('TokensInfo', ['tokenPrice']),
    ...mapGetters('Onboarding', ['operatorId']),
    ...mapGetters('ClientsInfo', ['isListed']),
    headers(): { [key: string]: string }[] {
      return [
        {
          text: 'Date',
          value: 'participationDate'
        },
        {
          text: 'Id',
          value: 'participationId'
        },
        {
          text: `Amount (${this.tokenSymbol})`,
          value: 'tokens'
        },
        {
          text: `Amount (${this.tokenPrice.rateCurrencyTicker})`,
          value: 'amountUSD'
        },
        {
          text: `Bonus (${this.tokenSymbol})`,
          value: 'bonus'
        },
        {
          text: 'Id TokenSale',
          value: 'tokenSaleId'
        }
      ];
    }
  },
  watch: {
    operatorId: {
      handler(newId: number | null): void {
        if (newId) {
          this.getUsersParticipation();
        }
      },
      immediate: true
    },
    isListed: {
      handler(status: number | null): void {
        if (!status && !this.isSuperAdmin) {
          this.$router.push('/');
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('TokenSale', ['getUsersParticipation']),
    usdToOperatorCurrency,
    roundNumber,
    getDate(date: string): string {
      return DateTime.fromSQL(date, { zone: 'UTC' })
        .toLocal()
        .toFormat('dd.MM.yy');
    },
    getTokens(participation: TokensaleParticipation): number | null {
      const { tokenSaleId, instantPayment, deferredPayment } = participation;
      switch (tokenSaleId) {
        case 1:
          return deferredPayment;
        case 2:
          return deferredPayment;
        case 3:
          return instantPayment;
        default:
          return null;
      }
    },
    getBonus(participation: TokensaleParticipation): number | null {
      const { tokenSaleId, instantPayment, deferredPayment } = participation;
      switch (tokenSaleId) {
        case 2:
          return instantPayment;
        case 3:
          return deferredPayment;
        default:
          return null;
      }
    }
  }
};
